import React, { useEffect, useReducer, useState } from 'react';
import { withStyles } from '@material-ui/core';

import ModalConfirmacao from '../../../../components/Modal/ModalConfirmacao/ModalConfirmacao';
import { ReactSelect, ReactSelectCheckbox } from '../../../../components/Select/SelectSearch';

import { weekDays } from '../../TransferenciaAgendamento/constants';
import { updateProcedimentosConfiguracaoHorarioAtendimento } from '../../../../services/ConfiguracaoHorarioAtendimentoService';
import { findConveniosByAtivo } from '../../../../services/ConvenioService';

const ConfigConvenioModal = ({
  classes,
  isOpen,
  diaSemana,
  horaInicio,
  convenios: conveniosProp,
  horarios,
  onClose,
  currentConfigVigente,
}) => {
  const [horariosOptions, setHorariosOptions] = useState([]);
  const [diaSemanaOptions, setDiaSemanaOptions] = useState([]);
  const [conveniosOptions, setConveniosOptions] = useState([]);
  const [conveniosSelecionados, setConveniosSelecionados] = useState([]);
  const [isLoading, toggleLoading] = useReducer((state) => !state, false);

  const handleChangeWeekDay = (selectedsDays) => {
    const updated = diaSemanaOptions.map((item) => ({
      ...item,
      checked: selectedsDays.some((opt) => opt.value === item.value),
    }));
    setDiaSemanaOptions(updated);
  };

  const handleChangeHours = (selectedHours) => {
    const updated = horariosOptions.map((item) => ({
      ...item,
      checked: selectedHours.some((opt) => opt.value === item.value),
    }));
    setHorariosOptions(updated);
  };

  const loadConvenios = async () => {
    try {
      const unidade = JSON.parse(localStorage.getItem("_immortal|unidade_logada") || "{}");
      const response = await findConveniosByAtivo(unidade?.id);
      const convenios = response?.data?.data?.convenios || [];
      setConveniosOptions(convenios.map(c => ({ value: c.id, label: c.descricao })));
    } catch (e) {
      console.error(e);
    }
  };

  const handleSaveConfig = async () => {
    const selectedsDays = diaSemanaOptions.filter((item) => item.checked);
    const selectedHours = horariosOptions.filter((item) => item.checked);
    let horariosAtendimento = currentConfigVigente.horariosAtendimento || [];

    const conveniosToSave = conveniosSelecionados.map(c => ({ id: c.value }));

    selectedsDays.forEach(day => {
      selectedHours.forEach(hour => {
        const index = horariosAtendimento.findIndex(
          config => config.diaSemana === day.value && config.horaInicio === hour.value
        );
        if (index > -1 && horariosAtendimento[index]?.permiteAgendamento) {
          horariosAtendimento[index].convenios = conveniosToSave;
        }
      });
    });

    try {
      toggleLoading();
      await updateProcedimentosConfiguracaoHorarioAtendimento({
        ...currentConfigVigente,
        horariosAtendimento,
      });
      onClose({ isReloadingConfig: true });
    } catch (error) {
      console.error(error);
    } finally {
      toggleLoading();
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    setHorariosOptions(horarios?.map(item => ({
      value: item,
      label: item,
      checked: item === horaInicio || false,
    })) || []);
    setDiaSemanaOptions(weekDays.map(item => ({
      value: item.value,
      label: item.nome,
      checked: item.value === diaSemana || false,
    })));
    setConveniosSelecionados(
      conveniosProp?.length > 0
        ? conveniosProp.map(c => ({ value: c.id, label: c.descricao }))
        : []
    );
    loadConvenios();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <ModalConfirmacao
      classes={{ paperAlert: classes.paperAlert }}
      open={isOpen}
      title="Configurar Convênios"
      idPrimaryButton="cfg-ccm-btn-can"
      idSecondButton="cfg-ccm-btn-sal"
      buttons={{
        labelPrimaryButton: 'Cancelar',
        handlePrimaryButton: () => onClose({ isReloadingConfig: false }),
        disabledPrimaryButton: isLoading,
        labelSecondButton: 'Salvar',
        handleSecondButton: handleSaveConfig,
        disabledSecondButton: isLoading,
        loadingSecondButton: isLoading,
      }}
    >
      <div className={classes.container}>
        <div className={classes.inputContainer}>
          <label className={classes.label}>Convênios</label>
          <ReactSelect
            id="cfg-ccm-sel-conv"
            options={conveniosOptions}
            value={conveniosSelecionados}
            onChange={(options) => setConveniosSelecionados(options || [])}
            isMulti
            isClearable
            placeholder="Todos os convênios"
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
          />
        </div>

        <div className={classes.inputContainer}>
          <label className={classes.label}>Dias da Semana</label>
          <ReactSelectCheckbox
            id="cfg-ccm-sel-dia"
            options={diaSemanaOptions}
            value={diaSemanaOptions.filter(item => item.checked)}
            onChange={handleChangeWeekDay}
          />
        </div>

        <div className={classes.inputContainer}>
          <label className={classes.label}>Horários</label>
          <ReactSelectCheckbox
            id="cfg-ccm-sel-hor"
            options={horariosOptions}
            value={horariosOptions.filter(item => item.checked)}
            onChange={handleChangeHours}
          />
        </div>
      </div>
    </ModalConfirmacao>
  );
};

const styles = {
  paperAlert: {
    maxWidth: '450px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px 0',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#505050',
  },
};

export default withStyles(styles)(ConfigConvenioModal);
